const header = document.querySelector("header");
const siteNavLinks = document.querySelectorAll(".site-nav__link");
const megaMenus = document.querySelectorAll(".meganav");
const megaMenuInnerTriggers = document.querySelectorAll(
  ".meganav-inner-trigger"
);
const megaMenuInners = document.querySelectorAll(
  ".site-nav__dropdown-container .site-nav__dropdown"
);

siteNavLinks.forEach(function (link) {
  link.addEventListener("mouseover", function () {
    siteNavLinks.forEach((link) => link.classList.remove("mega-nav--active"));
    megaMenus.forEach((dropdown) =>
      dropdown.classList.remove("meganav--active")
    );
    var ariaControls = this.getAttribute("aria-controls");
    var dropdown = document.querySelector("#" + ariaControls);
    if (!dropdown) return;
    link.classList.add("mega-nav--active");
    dropdown.classList.add("meganav--active");
  });
});

megaMenuInnerTriggers.forEach(function (link) {
  link.addEventListener("mouseover", function () {
    megaMenuInnerTriggers.forEach(function (link) {
      link.classList.remove("mega-nav--active");
    });
    link.classList.add("mega-nav--active");
    var ariaControls = this.getAttribute("aria-controls");
    var dropdown = document.querySelector("#" + ariaControls);
    megaMenuInners.forEach(function (dropdown) {
      dropdown.classList.remove("meganav--active");
    });
    megaMenuInnerTriggers.forEach((l) => {
      l.closest(".site-nav__dropdown-container")?.classList.remove(
        "meganav--active"
      );
    });
    link
      .closest(".site-nav__dropdown-container")
      ?.classList.add("meganav--active");
    if (!dropdown) return;
    dropdown.classList.add("meganav--active");
  });
});

header.addEventListener("mouseleave", function () {
  siteNavLinks.forEach(function (link) {
    link.classList.remove("mega-nav--active");
  });

  document.querySelectorAll(".site-nav__dropdown").forEach(function (dropdown) {
    dropdown.classList.remove("meganav--active");
  });

  var dropdowns = document.querySelectorAll(".meganav");
  dropdowns.forEach(function (dropdown) {
    dropdown.classList.remove("meganav--active");
  });

  document
    .querySelector(".site-header__search-inner")
    .classList.remove("search-header__search-inner--active");
  document
    .querySelector("#SiteNavSearch")
    .classList.remove("site-header__search-input--visible");
});

document.addEventListener("scroll", function () {
  header.classList.toggle("scrolled", window.scrollY > 0);
});

function updateFreeGift(cart) {
  const freeGiftCost = parseFloat(
    document.querySelector("header").dataset.freeGiftCost
  );
  const freeGiftProductId =
    document.querySelector("header").dataset.freeGiftProduct;
  const cartTotal = cart.total_price / 100;
  const freeGiftInCart = cart.items.some(
    (item) => item.variant_id === parseInt(freeGiftProductId)
  );

  if (!freeGiftCost || !freeGiftProductId) return;

  if (cartTotal >= freeGiftCost && !freeGiftInCart) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: freeGiftProductId,
        quantity: 1,
      }),
    })
      .then((res) => res.json())
      .then((response) =>
        refreshIfCartPage(response)
      );
  } else if (cartTotal < freeGiftCost && freeGiftInCart) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: freeGiftProductId,
        quantity: 0,
      }),
    })
      .then((res) => res.json())
      .then((response) =>
        refreshIfCartPage(response)
      );
  }
}

function refreshIfCartPage() {
  if (window.location.pathname.includes("/cart")) {
    document.dispatchEvent(new Event("cart-page:refresh"));
  }
}

function updateCartIndicator(cartInfo) {
  const cartIndicator = document.querySelector(".site-header__cart-indicator");
  cartIndicator.textContent = cartInfo.item_count;
}

document.addEventListener("cart:updated", function (event) {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      updateFreeGift(cart);
      updateCartIndicator(cart);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});

//get all upsells and add them to the cart on click
document.querySelectorAll(".pdp-upsell__checkbox").forEach(function (checkbox) {
  checkbox.addEventListener("change", function (e) {
    const upsellId = e.target.value;
    
    if (e.target.checked) {
      //disable the checkbox
      e.target.disabled = true;
      const items = [
        {
          id: upsellId,
          quantity: 1,
        },
      ];
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items }),
      });
    }
  });
});
